'use strict';

const React = require('react');
const PropTypes = require('prop-types');

const TYPE_LIGHT = 'light';
const TYPE_DARK = 'dark';
const TYPE_TRANSPARENT = 'transparent';
const TYPE_COLORED = 'colored';


const SocialIcon = React.createClass({
    propTypes: {
        Icon: PropTypes.func.isRequired,
        iconName: PropTypes.string.isRequired,
        iconType: PropTypes.oneOf([TYPE_LIGHT, TYPE_DARK, TYPE_TRANSPARENT, TYPE_COLORED])
    },

    getDefaultProps() {
        return {
            iconType: TYPE_LIGHT
        };
    },

    render() {
        const {Icon, iconName, iconType, ...other} = this.props;

        return (
            <div className={`svg-icon-wrapper social-button-${iconType} ${iconName}`} title={iconName} {...other}>
                <Icon className="social-icon" />
            </div>
        );
    }
});

module.exports = SocialIcon;



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialIcon.jsx